module.exports = __webpack_public_path__ + "img/affiliate.8e1a05c1.svg";